<template>

  <div v-if="votes">

    <span v-if="!entries.length">
      <div v-if="$store.getters.user" class="hit-panel hit-panel-default">
        <div class="hit-panel-body" v-html='$tc("message.feedback", 2)+": "+$tc("message.noEntry", 2)' v-bind:style="{'background-color': survey.colors.accent_color, 'border-color': survey.colors.accent_color, 'color': survey.colors.accent_color2}" />
      </div>
    </span>

    <transition-group name="fade" tag="ul" class="hit-list-group" >
      <li v-for="(entry, index) in filterEntries" :key="index" class="hit-list-group-item" v-bind:style="{'background-color': survey.colors.background_color, 'border-color': survey.colors.accent_color2}">
        <div class="hit-row">
          <div class="hit-col-xs-1"><span class="icon" v-bind:style="{'background-color': survey.colors.accent_color, color: survey.colors.accent_color2}">{{ entry.name[0] }}</span> </div>
          <div class="hit-col-xs-11 hit-text-left"><div><b v-bind:style="{'color': survey.colors.text_color}">{{ entry.name }}</b></div>
            <hit_stars :stars="entry.average" v-bind:style="{'color': survey.colors.accent_color}" />
            <span class="date" v-bind:style="{'color': survey.colors.text_color}">{{ new Date(entry.time).getDate() }}.{{ new Date(entry.time).getMonth()+1 }}.{{ new Date(entry.time).getFullYear() }}</span>


            <div style="margin-top: 10px; font-size: 0.7em" v-bind:key="detailsKey" v-bind:style="{'color': survey.colors.text_color}">

              <div v-for="(star, i) in details[entry.ID].stars" :key="'star_'+index+'_'+i" style="margin-bottom: 10px">
                <div><b>{{ Object.keys(star)[0] }}</b></div>
                <hit_stars :stars="Object.values(star)[0]" v-bind:style="{'color': survey.colors.text_color}" />
                <blockquote style="margin:0; margin-left: 4px; margin-top: 3px" class="hit-blockquote" v-if="Object.values(details[entry.ID].description[i])[0]"><i>{{ Object.values(details[entry.ID].description[i])[0] }}</i></blockquote>
              </div>

            </div>

          </div>


        </div>
        <div class="hit-row" style="margin-top: 10px" v-if="details[entry.ID].adminComment">
          <div class="hit-col-xs-1"><span class="icon" v-bind:style="{'background-color': survey.colors.text_color, color: survey.colors.accent_color}">{{ details[entry.ID].board.user.username[0] }}</span> </div>
          <div class="hit-col-xs-11 hit-text-left"><div><b v-bind:style="{'color': survey.colors.text_color}">{{ $t("message.answerFromAdmin") }}</b> <div v-bind:style="{color: survey.colors.text_color}" v-html="details[entry.ID].adminComment"></div></div></div>
        </div>
      </li>
    </transition-group>

    <div class="hit-form-group" v-if="entries.length - end > 0" v-bind:style="{'color': survey.colors.text_color}">
      {{ end }}/<a href="#" v-bind:style="{'color': survey.colors.accent_color}" class="hit-html-a" v-on:click.prevent="end = entries.length">{{entries.length}}</a> {{ $tc("message.feedback", entries.length) }}
      <a href="#" v-bind:style="{'color': survey.colors.accent_color}" class="hit-html-a"  v-on:click.prevent="end += steps">{{ $t("message.next") }}</a>

    </div>

  </div>

</template>

<script>



import vote_details from '@core/components/votes/parts/details'
import md5 from 'js-md5'

export default{

  components: {vote_details},
  props: {survey: Object, design: String, votes: Array, entries: Array},

  data: function () {

    return {
      titles: [this.$t('message.username'), this.$tc('message.feedback', 1), this.$t('message.date')],
      key: 1,
      details: false,
      steps: 5,
      end: 5,
      details:{},
      detailsKey: 0
    }
  },

  computed: {

    filterEntries(){

      var r = [];

      this.entries.forEach(function(entry, index){

        if(index < this.end){
          this.get_details(entry.ID);
          r.push(entry);
        }

      }.bind(this));

      return r;

    }

  },

  methods: {

    set_key: function(add){

      this.key = this.key + add;

      if(this.key > this.entries.length)
        this.key = 1;

      if(this.key < 1)
        this.key = this.entries.length;

      this.set_details();
    },

    get_details: function(ID){

      if(typeof this.details[ID] == "object")
        return false;

      this.$hit_post({url: 'hitclick/votes/get_vote',
        data: {user: this.survey.user, board: md5(this.survey.ID+''), ID: md5(ID)},
        callback: function (ret) {
          this.details[ID] = ret.data[1];
          this.detailsKey = new Date().getTime()+Math.random(0,1000)*100;
        }.bind(this)
      }
    );

  },

    set_details: function(){

      var row = this.key;


      this.$hit_post({url: 'hitclick/votes/get_vote',
        data: {user: this.survey.user, board: md5(this.survey.ID+''), ID: md5(this.entries[row].ID+'')},
        callback: function (ret) {


          if (ret.data[0]) {

            if(ret.data[0]){
              this.details = ret.data[1]
              this.details.hint = "";
            }

          }
        }.bind(this)})



    },

  },

  mounted(){

    this.key = 1;


  }



}

</script>

<style lang="sass" scoped>
  $width: 35px

  .icon
    display: inline-block
    width: $width
    height: $width
    background-color: lightgrey
    padding: 8px
    box-sizing: border-box
    border-radius: 50%
    text-align: center

  .date
    opacity: 0.8
    font-size: 10pt
    margin-left: 5px
</style>
